if (!customElements.get('selling-plan-picker')) {
    customElements.define('selling-plan-picker', class SellingPlanPicker extends HTMLElement {
        constructor() {
            super();
        }
        
        connectedCallback() {
            this.productWrapper = this.closest('.product__info-container') || this.closest('.card');
            if (!this.productWrapper) return
            
            this.productForm = this.productWrapper.querySelector('product-form');
            if (!this.productForm) return
            
            this.form = this.productForm.querySelector('form');
            if (!this.form) return
            
            this.variantPicker = this.productWrapper.querySelector('variant-radios') || this.productWrapper.querySelector('variant-selects');

            this.toggleSellingPlan()
            this.bindPurchaseOptions()
            this.toggleElementsVisibility()

            Array.from(this.querySelectorAll('input, select')).forEach((el) => {
                el.addEventListener('change', (ev) => {
                    this.triggerChanges(ev)
                })
            })

            this.variantChangeCallback()
        }

        subscriptionDefault() {
            if (!this.variantPicker?.userPickedVariant) {
                this.productWrapper = this.closest('.product__info-container') || this.closest('.card');
                this.productWrapper.setAttribute('data-variant', 'true')
                const onetimeRadio = this.querySelector('[name="purchase_option"][value="onetime"]')
                const sellingPlanRadio = this.querySelector('[name="purchase_option"][value="selling_plan"]')
                const sellingPlanSelect = this.querySelector('select[name="selling_plan"]')

                if (onetimeRadio && sellingPlanRadio) {
                    onetimeRadio.checked = false
                    sellingPlanRadio.checked = true
                    sellingPlanRadio.dispatchEvent(new Event('change'))
                    if (sellingPlanSelect) {
                        sellingPlanSelect.disabled = false
                    }
                }

                if (this.variantPicker) {
                    const selectedOption1 = this.variantPicker.querySelector('[data-option-value] input:checked')
                    if (selectedOption1) {
                        const selectedOption1Wrapper = selectedOption1.closest('[data-option-value]')
                        if (!!selectedOption1Wrapper?.dataset.hasSellingPlan === false) {
                            this.variantPicker.querySelector('[data-option-value][data-has-selling-plan] input').checked = true
                        }
                    }
                }

                this.toggleElementsVisibility()
            }
        }

        triggerChanges(ev) {
            if (ev.target?.value === 'selling_plan') {
                // select subscription option if subscription frequency is selected while one time is selected
                const purchaseOption = this.querySelector('[name="purchase_option"]:checked')
                const sellingPlanRadio = this.querySelector('input[type="radio"][name="selling_plan"]')
                const selectedSellingPlanRadio = this.querySelector('input[type="radio"][name="selling_plan"]:checked')
                if (purchaseOption && purchaseOption.value === 'onetime' && sellingPlanRadio && selectedSellingPlanRadio) {
                    this.querySelector('[name="purchase_option"][value="selling_plan"]').checked = true
                }
                if (this.variantPicker) {
                    const selectedOption1 = this.variantPicker.querySelector('[data-option-value] input:checked')
                    if (selectedOption1) {
                        const selectedOption1Wrapper = selectedOption1.closest('[data-option-value]')
                        if (!!selectedOption1Wrapper?.dataset.hasSellingPlan === false) {
                            this.variantPicker.querySelector('[data-option-value][data-has-selling-plan] input').click()
                        }
                    }
                }
            }

            this.toggleElementsVisibility()

            if (this.variantPicker) {
                this.variantPicker.dispatchEvent(new Event("change"));
            } else {
                this.updateURL();
                this.renderProductInfo();
            }
        }

        toggleSellingPlan() {
            const purchaseOption = this.querySelector('[name="purchase_option"]:checked')

            // select first subscription frequency if subscription is selected but no frequency is selected
            const sellingPlanRadio = this.querySelector('input[type="radio"][name="selling_plan"]')
            const selectedSellingPlanRadio = this.querySelector('input[type="radio"][name="selling_plan"]:checked')
            if (purchaseOption && purchaseOption.value === 'selling_plan' && sellingPlanRadio && !selectedSellingPlanRadio) {
                sellingPlanRadio.checked = true
            }

            const sellingPlanOption = this.querySelector('select[name="selling_plan"]')
            if (!sellingPlanOption) return

            if (!purchaseOption || purchaseOption.value === 'onetime') {
                sellingPlanOption.disabled = true
            } else if (purchaseOption && purchaseOption.value === 'selling_plan') {
                sellingPlanOption.disabled = false
            }
        }

        updateURL() {
            const variantId = this.productForm.querySelector('input[name="id"]').value;
            const currentSellingPlanId = this.getCurrentSellingPlanId();
            let params = '';
            params += `variant=${variantId}`;
            if (currentSellingPlanId) {
                params += `&selling_plan=${currentSellingPlanId}`;
            }
            window.history.replaceState({ }, '', `${this.dataset.url}?${params}`);
        }

        getCurrentSellingPlanId() {
            let currentSellingPlanId
            if (this.querySelector('input[name="purchase_option"][value="onetime"]:checked') ) {
                return currentSellingPlanId
            } else if (this.querySelector('select[name="selling_plan"]')) {
                const sellingPlanOption = this.querySelector('select[name="selling_plan"]')
                currentSellingPlanId = sellingPlanOption.options[sellingPlanOption.selectedIndex]?.value
            } else if (this.querySelector('input[name="selling_plan"]:checked')) {
                currentSellingPlanId = this.querySelector('input[name="selling_plan"]:checked')?.value
            }
            
            if (this.variantPicker) {
                const checkedOption = this.variantPicker.querySelector('.product-form__input input:checked')
                if (checkedOption) {
                    const checkedOptionWrapper = checkedOption.closest('[data-has-selling-plan]')
                    if (checkedOptionWrapper) {
                        const newSellingPlanId = checkedOptionWrapper.dataset.hasSellingPlan
                        if (newSellingPlanId) {
                            currentSellingPlanId = newSellingPlanId
                        }
                    }
                }
            }

            return currentSellingPlanId
        }

        bindPurchaseOptions() {
            Array.from(this.querySelectorAll('[name="purchase_option"]')).forEach((input) => {
                input.addEventListener('change', (ev) => {
                    this.toggleSellingPlan()
                })
            })
        }

        renderProductInfo() {
            const requestedVariantId = this.productForm.querySelector('input[name="id"]').value;
            const currentSellingPlanId = this.getCurrentSellingPlanId();
                
            let params = '';
            params += `variant=${requestedVariantId}`;
            if (currentSellingPlanId) {
                params += `&selling_plan=${currentSellingPlanId}`;
            }

            const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        
            fetch(
              `${this.dataset.url}?${params}&section_id=${sectionId}`
            )
                .then((response) => response.text())
                .then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const destination = document.getElementById(`price-${this.dataset.section}`);
                    const source = html.getElementById(
                        `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                    );
                    const skuSource = html.getElementById(
                        `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                    );
                    const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                    const inventorySource = html.getElementById(
                        `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                    );
                    const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
            
                    const volumePricingSource = html.getElementById(
                        `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                    );
            
                    const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
                    const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
            
                    const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
            
                    if (source && destination) destination.innerHTML = source.innerHTML;
                    if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                    if (skuSource && skuDestination) {
                        skuDestination.innerHTML = skuSource.innerHTML;
                        skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
                    }
            
                    if (volumePricingSource && volumePricingDestination) {
                        volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
                    }
            
                    if (pricePerItemSource && pricePerItemDestination) {
                        pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
                        pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
                    }
            
                    const price = document.getElementById(`price-${this.dataset.section}`);
            
                    if (price) price.classList.remove('visibility-hidden');
            
                    if (inventoryDestination)
                        inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');
                });
        }

        toggleElementsVisibility() {
            if (this.querySelector('input[name="purchase_option"][value="selling_plan"]:checked')) {
                this.dataset.purchaseOption = 'selling_plan'
            } else {
                this.dataset.purchaseOption = 'onetime'
            }
            // window.setTimeout(() => {
            //     const hasSellingPlan = !!this.getCurrentSellingPlanId()
            //     console.debug('toggleElementsVisibility', {hasSellingPlan})
            //     const sellingPlanOnlyEls = Array.from(document.querySelectorAll('[data-subscription-only]'))
            //     const oneTimeOnlyEls = Array.from(document.querySelectorAll('[data-onetime-only]'))
            //     if (hasSellingPlan) {
            //         sellingPlanOnlyEls.forEach((el) => {
            //             el.classList.remove('hidden')
            //         })
            //         oneTimeOnlyEls.forEach((el) => {
            //             el.classList.add('hidden')
            //         })                    
            //     } else {
            //         sellingPlanOnlyEls.forEach((el) => {
            //             el.classList.add('hidden')
            //         })
            //         oneTimeOnlyEls.forEach((el) => {
            //             el.classList.remove('hidden')
            //         })
            //     }
            // }, 200)
        }

        variantChangeCallback() {
            window.addEventListener('variantChanged', (ev) => {
                if (this.variantPicker?.userPickedVariant) {
                    const sellingPlanDestination = document.querySelector(`selling-plan-picker[data-section="${ev.detail.sectionId}"]`);
                    const sellingPlanSource = ev.detail.html.querySelector(`selling-plan-picker[data-section="${ev.detail.sectionId}"]`);
                    if (sellingPlanDestination && sellingPlanSource) {
                        sellingPlanDestination.replaceWith(sellingPlanSource)
                    }
                }
            })
        }
    })
}